export const GET_SUB_ADMIN = "GET_SUB_ADMIN";
export const CREATE_SUB_ADMIN = "CREATE_SUB_ADMIN";
export const UPDATE_SUB_ADMIN = "UPDATE_SUB_ADMIN";
export const DELETE_SUB_ADMIN = "DELETE_SUB_ADMIN";
